<template>
  <div>
    <Navbar />
    <div class="d-flex" id="wrapper">
      <div class="bg-light border-right" id="sidebar-wrapper">
        <Sidebar active="Dashboard" />
      </div>
      <div id="page-content-wrapper">
        <div class="container-fluid">
          <!-- @include('blocks.page-content-header') -->
          <PageContentHeader
            :data="data"
            :fromUrl="fromUrl || ''"
            :fromTab="$route.query.fromTab || ''"
          />
          <div class="card-with-tab mb-3">
            <div class="">
              <ul class="nav nav-pills">
                <li
                  v-for="tab in upperTabs"
                  v-bind:key="tab.link"
                  class="nav-item"
                >
                  <router-link
                    :to="tab.link"
                    :class="
                      `nav-link ${
                        tab.label == 'REKAPITULASI LAPORAN' ? 'active' : ''
                      }`
                    "
                    >{{ tab.label }}</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <LeftMenuRl active="rl2" />
            </div>
            <div class="col-md-10">
              <div class="row">
                <div class="col-md-9">
                  <PageContentHeader
                    :data="dataRl"
                    :fromUrl="fromUrl || ''"
                    :fromTab="$route.query.fromTab || ''"
                  />
                </div>
                <div class="col-md-3">
                  <download-excel
                    class="btn btn-default btn-primary btn-block"
                    :data="combinedData"
                    worksheet="RL-2"
                    name="rekapitulasi_laporan_2"
                  >
                    Download Excel
                  </download-excel>
                </div>
              </div>

              <div class="card mb-4">
                <div class="card-body">
                  <h4>Formulir RL 2 Ketenagaan</h4>
                  <table>
                    <tbody>
                      <tr
                        v-for="item in rl2"
                        v-bind:key="item.key + Math.random(1023) * 1000"
                      >
                        <td
                          :class="
                            `pb-2 ` + (item.content === '' ? 'pt-4' : 'pt-2')
                          "
                        >
                          <strong
                            :style="
                              item.content === ''
                                ? 'font-size:14px;color:#097ceb'
                                : ''
                            "
                            >{{ item.title }}</strong
                          >
                        </td>
                        <td
                          :class="
                            `pl-4 pr-2 pb-2 ` +
                              (item.content === '' ? 'pt-4' : 'pt-2')
                          "
                        >
                          {{ item.content !== "" ? " : " : "" }}
                        </td>
                        <td
                          :class="
                            `pr-1 pb-2` +
                              (item.content === '' ? 'pt-4' : 'pt-2')
                          "
                        >
                          {{ item.content }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
// import DoughnutChart from "@/components/DoughnutChart.js";
// import BarChart from "@/components/BarChart.js";
import HorizontalBarChart from "@/components/HorizontalBarChart.js";
import Loading from "@/components/Loading.vue";
import EmptyState from "@/components/EmptyState.vue";
import Navbar from "@/components/Navbar.vue";
import Sidebar from "@/components/Sidebar.vue";
import PageContentHeader from "@/components/PageContentHeader.vue";
import FormRow from "@/components/FormRow.vue";
import LeftMenuRl from "@/components/LeftMenuRl.vue";
import { ageInterval, getInputDate } from "@/data/helper.js";
// import { HTTP } from "@/config.js";
import {
  data,
  dataRl2,
  tabs,
  filtersRujukan,
  sort,
  upperTabs,
} from "@/data/Dashboard.js";
//import jQuery from 'jquery';
//import bootstrap from '@/vendor/bootstrap.js';
export default {
  name: "DashboardRujukan",
  components: {
    Navbar,
    Sidebar,
    PageContentHeader,
    LeftMenuRl,
  },
  data: () => {
    return {
      fromUrl: "",
      plainUrl: "",
      loaded: true,
      data: data,
      dataRl: dataRl2,
      upperTabs: upperTabs,
      LeftMenuRl: LeftMenuRl,
      rl2: [],
      combinedData: [],
    };
  },
  methods: {
    combineData: async function() {
      this.combinedData = [
        {
          Judul: "Formulir RL 2 Ketenagaan",
          Data: "",
        },
        {
          Judul: "",
          Data: "",
        },
        ...this.rl2.map(function(item) {
          return { Judul: item.title, Data: String(item.content) };
        }),
      ];
    },
    displayData: async function(rl, endpoint) {
      this.errors = [];
      try {
        let result = await this.$store.state.HTTP.get(endpoint);
        //console.log(result);
        if (result.status == "200") {
          Object.keys(result.data).forEach(function(key) {
            let content = "";
            if (typeof result.data[key] !== "object") {
              content = result.data[key];
            }
            rl.push({
              title: key
                .replace(/_/g, " ")
                .split(" ")
                .map((word) => word[0].toUpperCase() + word.slice(1))
                .join(" "),
              key: key,
              content: content,
            });
            if (typeof result.data[key] === "object") {
              Object.keys(result.data[key]).forEach(function(innerKey) {
                let innerContent = "";
                if (typeof result.data[key][innerKey] !== "object") {
                  innerContent = result.data[key][innerKey];
                }
                rl.push({
                  title: innerKey
                    .replace(/_/g, " ")
                    .split(" ")
                    .map((word) => word[0].toUpperCase() + word.slice(1))
                    .join(" "),
                  key: innerKey,
                  content: innerContent,
                });
                if (typeof result.data[key][innerKey] === "object") {
                  Object.keys(result.data[key][innerKey]).forEach(function(
                    innerInnerKey
                  ) {
                    let innerInnerContent = "";
                    if (
                      typeof result.data[key][innerKey][innerInnerKey] !==
                      "object"
                    ) {
                      innerInnerContent =
                        result.data[key][innerKey][innerInnerKey];
                    }
                    rl.push({
                      title: innerInnerKey
                        .replace(/_/g, " ")
                        .split(" ")
                        .map((word) => word[0].toUpperCase() + word.slice(1))
                        .join(" "),
                      key: innerInnerKey,
                      content: innerInnerContent,
                    });
                  });
                }
              });
            }
          });
          ////console.log(self.formSet);
        } else {
          this.errors.push(result.status);
        }
      } catch (e) {
        ////console.log(e);
        this.errors.push(e);
      }
    },
  },
  beforeRouteEnter: function(to, from, next) {
    next((vm) => {
      vm.fromUrl = ["", "/"].indexOf(from.path) > -1 ? "" : from.fullPath;
      ////console.log(vm.fromUrl);
    });
  },
  mounted: async function() {
    await this.displayData(this.rl2, "rekapitulasi_laporan_2");
    await this.combineData();
  },
};
</script>
